// Drop-off tab — native in-app form (dropbox QR lands here: /drop?src=qr).
import { DropForm } from "./DropForm";

export function Drop() {
  return <DropForm formType="drop-off" />;
}
